import { SeoRenderer } from "../../../common/helpers/seo";

import loadingComponent from "./loadable";

export default {
    component: loadingComponent,
    renderSeo: (store, allMessage, lang) => {
        SeoRenderer({ title: allMessage["etp.verifyEmail.title"], allMessage, lang });
    },
};
